const openMegaMenu = (elm) => {
    elm.classList.add('opened')
}

const initMegaMenu = () => {
    const megamenuToggles = document.querySelectorAll('.megamenu-js-toggle')
    const megaMenus = document.querySelectorAll('.megamenu-js')

    megamenuToggles.forEach((megamenuToggle) => {
        const { megamenuId } = megamenuToggle.dataset
        const megamenu = document.querySelector(`[data-id="${megamenuId}"]`)
        
        megamenuToggle.addEventListener('mouseover', () => {
            megamenuToggle.classList.add('active')
            megamenu.classList.add('opened')
        })

        megamenuToggle.addEventListener('mouseleave', () => {
            megamenuToggle.classList.remove('active')
            megamenu.classList.remove('opened')
        })
    })

    megaMenus.forEach((megaMenu) => {
        const { id } = megaMenu.dataset
        const megaMenuToggle = document.querySelector(`[data-megamenu-id="${id}"`)

        megaMenu.addEventListener('mouseleave', () => {
            megaMenu.classList.remove('opened')
            megaMenuToggle.classList.remove('active')
        })

        megaMenu.addEventListener('mouseover', () => {
            megaMenu.classList.add('opened')
            megaMenuToggle.classList.add('active')
        })
    })
}

export { initMegaMenu }